import { useEffect, ReactNode } from 'react';
import { useDispatch } from 'react-redux';
import type { AppDispatch } from 'state/store';
import { getEmployeeDetailsThunk } from 'state/azure-active-directory/aad-thunks';

type EmployeeDetailsProps = {
  children?: ReactNode;
};

export const EmployeeDetails = ({ children }: EmployeeDetailsProps) => {
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    const callApi = async () => {
      try {
        await dispatch(getEmployeeDetailsThunk());
      } catch (e) {
        e && console.error(e);
      }
    };

    callApi();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return children;
};
